import { DropdownMenu } from "@skailer-com/uikit";
import { ReactNode, useState } from "react";
import { twMerge } from "tailwind-merge";

export function HiringFlowRowMenu({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      className={twMerge(
        "opacity-0 transition-opacity group-hover:opacity-100 has-[:focus-visible]:opacity-100 pointer-coarse:opacity-100",
        open && "opacity-100"
      )}
    >
      {children}
    </DropdownMenu>
  );
}
